// Contentful Entry ID for Summary Page subtitle
export const SUMMARY_SUBTITLE_ENTRY_ID = '2atyF2LMTIhHVMVbpYtqzN';
